import { BrowserRouter, Route, Routes } from "react-router-dom";
import { QRGenerator } from "./app/pages/pix/QRGenerator";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<QRGenerator />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
